import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';

function TableMonitoring({ children, tableHeader }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        {tableHeader}
        <TableBody>
          {children}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TableMonitoring